module.exports = __webpack_public_path__ + "static/media/no-connection.a57e9f0e.svg";